import { ShelvableBackend, LoginOptions } from '../../services/ShelvableBackend/ShelvableBackend';

import { Component, ViewEncapsulation } from '@angular/core';
import swal from 'sweetalert';

import { Observable } from 'rxjs'

@Component({
    selector: 'home',
    templateUrl: './home.html',
    encapsulation: ViewEncapsulation.None
})
export class HomeComponent {
    public authState;
    public login:(provider:String, options:LoginOptions) => void;

    isLoggedIn:Observable<boolean>;
    isRegistered:Observable<boolean>;
    username:Observable<string>;

    constructor(shelvableBackend:ShelvableBackend) {
        this.authState = shelvableBackend.authState;
        this.isRegistered = shelvableBackend.loggedInUserObs.isRegisteredObs;
        this.isLoggedIn = shelvableBackend.loggedInUserObs.isLoggedIn;
        this.username = shelvableBackend.loggedInUserObs.usernameObs;

        this.login = function (provider:String, options:LoginOptions) {
            shelvableBackend.loginWithProvider(provider, options).catch(function(error) {
                console.error(error);
                swal("There was an issue logging you in.", "Sorry about that.", "error");
            });
        };
    };
};



// WEBPACK FOOTER //
// ./web/static/components/home/home.ts